<template>
  <transition name="fade">
    <div
      v-show="show"
      class="toast"
    >
      <span><i v-if="type" />{{ text }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CompToast',
  props: {
    type: {
      type: Boolean,
      default: false,
      // validator: val => ['info', 'success', 'warning', 'error'].includes(val)
      // ['info', 'success', 'warning', 'error'] 表示type只接收这四个字符串作为参数传入message组件
    },
    text: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
